// extracted by mini-css-extract-plugin
export var banner = "_28-0";
export var icon = "_28-1";
export var message = "_28-2";